const UserGroup = {
  'pages_user_UserGroup.groupName': '그룹명',
  'pages_user_UserGroup.pleaseInsertGroupName': '그룹명을 입력해 주세요.',
  'pages_user_UserGroup.pleaseInsertSearchGroupName': '가입할 그룹명을 지정해 주세요.',
  'pages_user_UserGroup.searchGroup': '검색',
  'pages_user_UserGroup.pleaseJoinGroup': '그룹에 가입하세요.',
  'pages_user_UserGroup.createAGroup': '그룹 생성',
  'pages_user_UserGroup.doCreateAGroup': '그룹을 생성합니다.',
  'pages_user_UserGroup.pleaseInsertGroupName': '그룹명을 지정해 주세요.',
  'pages_user_UserGroup.confirmCreateGroup': '그룹을 생성 하시겠습니까?',
  'pages_user_UserGroup.hasCreatedGroup': '그룹을 생성 하였습니다.',
  'pages_user_UserGroup.joinAGroup': '그룹 가입',
  'pages_user_UserGroup.doJoinAGroup': '그룹에 가입합니다.',
  'pages_user_UserGroup.forUseOpsNow.line.One': 'OpsNow를 이용하기 위해서는 회원님이 속할',
  'pages_user_UserGroup.forUseOpsNow.line.Two': '그룹을 지정해야 합니다.',
  'pages_user_UserGroup.YouCanCreateGroup': '회원님이 관리할 그룹을 직접 생성할 수도 있고',
  'pages_user_UserGroup.orJoinAGroup': '이미 생성된 그룹에 가입할 수도 있습니다.',
  'pages_user_UserGroup.sendJoinMail': '가입 요청 메일 발송',
  'pages_user_UserGroup.pleaseSelectEmail': '가입 요청 메일을 선택하십시오.',
  'pages_user_UserGroup.hasNoAdmin': '그룹에 관리자가 존재하지 않아 가입할 수가 없습니다.',
  'pages_user_UserGroup.hasSendJoinRequest': '가입 요청 완료 했습니다.',
  'pages_user_UserGroup.hasJoinedGroup': '그룹에 가입돼 있습니다.',
  'pages_user_UserGroup.confirmJoinGroup': '그룹에 가입 하시겠습니까?',
  'pages_user_UserGroup.waitingForApprove': '가입 승인 대기중입니다.',
  'pages_user_UserGroup.hasSendMailToAdmin': '관리자가 승인하면 이메일로 알려드립니다.',
  'pages_user_UserGroup.waitForApprove': '승인 완료를 기다려주시기 바랍니다.',
  
}

export default UserGroup



// WEBPACK FOOTER //
// ./src/lang/user/components/UserGroup.kr.js